import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  categoryButton: {
    marginTop: 10,
    minHeight: 80,
    color: "#FFFFFF",
    background: "#626262",
    textTransform: "none",
    width: "100%",
    "&:hover": {
      background: "#626262",
    },
  },
  categoryButtonBlue: {
    marginTop: 10,
    minHeight: 80,
    color: "#FFFFFF",
    background: "#1D3557",
    textTransform: "none",
    width: "100%",
    "&:hover": {
      background: "#1D3557",
    },
  },
  categoryButtonRed: {
    marginTop: 10,
    minHeight: 80,
    color: "#FFFFFF",
    background: "#7B0000",
    textTransform: "none",
    width: "100%",
    "&:hover": {
      background: "#7B0000",
    },
  },
  categoryButtonGreen: {
    marginTop: 10,
    minHeight: 80,
    color: "#FFFFFF",
    background: "#66bb6a",
    textTransform: "none",
    width: "100%",
    "&:hover": {
      background: "#66bb6a",
    },
  },
}));

const CategoryButton = ({ onClick, label, blue, red, green, mobile }) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      size="medium"
      className={
        blue
          ? classes.categoryButtonBlue
          : red
          ? classes.categoryButtonRed
          : green
          ? classes.categoryButtonGreen
          : classes.categoryButton
      }
      onClick={onClick}
      style={
        mobile
          ? {
              minHeight: 40,
              borderRadius: 20,
            }
          : {}
      }
    >
      {label}
    </Button>
  );
};

export default CategoryButton;
